var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _rect, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEWalletRafiki(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.3,
    y: 110.85,
    width: 46.48,
    height: 31.06,
    rx: 3.87,
    transform: "translate(223.49 -207.59) rotate(51.79)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.92,
    y: 127.71,
    width: 46.48,
    height: 5.81,
    transform: "translate(224.77 -201.74) rotate(51.79)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.76,
    y: 137.97,
    width: 7.87,
    height: 2.06,
    transform: "translate(432.5 487.97) rotate(-128.21)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.64,
    y: 131.95,
    width: 4.63,
    height: 2.06,
    transform: "translate(429.56 474.5) rotate(-128.21)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.86,
    y: 125.87,
    width: 4.63,
    height: 2.06,
    transform: "translate(426.58 460.91) rotate(-128.21)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.68,
    y: 181.52,
    width: 46.48,
    height: 31.06,
    rx: 3.87,
    transform: "translate(319.55 220.99) rotate(123.11)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.94,
    y: 190.41,
    width: 46.48,
    height: 5.81,
    transform: "translate(307.56 220.01) rotate(123.11)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.96,
    y: 208.74,
    width: 7.87,
    height: 2.06,
    transform: "translate(-134.47 171.33) rotate(-56.89)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.77,
    y: 202.32,
    width: 4.63,
    height: 2.06,
    transform: "translate(-127.19 171.93) rotate(-56.89)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.99,
    y: 195.84,
    width: 4.63,
    height: 2.06,
    transform: "translate(-119.85 172.52) rotate(-56.89)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.17,
    y: 314.56,
    width: 46.48,
    height: 31.06,
    rx: 3.87,
    transform: "translate(-99.8 471.07) rotate(-55.64)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.82,
    y: 331.05,
    width: 46.48,
    height: 5.81,
    transform: "translate(-100.53 477.42) rotate(-55.64)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.77,
    y: 316.54,
    width: 7.87,
    height: 2.06,
    transform: "translate(896.82 161.85) rotate(124.35)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.07,
    y: 322.86,
    width: 4.63,
    height: 2.06,
    transform: "translate(895.28 175.31) rotate(124.36)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.7,
    y: 329.25,
    width: 4.63,
    height: 2.06,
    transform: "translate(893.73 188.91) rotate(124.36)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.84,
    y: 285.95,
    width: 55.44,
    height: 37.04,
    rx: 4.62,
    transform: "translate(574.62 553.4) rotate(168.96)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.28,
    y: 293,
    width: 55.44,
    height: 6.93,
    transform: "translate(569.98 537.82) rotate(168.96)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.48,
    y: 306.09,
    width: 9.39,
    height: 2.46,
    transform: "translate(-54.38 52.07) rotate(-11.04)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.38,
    y: 304.34,
    width: 5.52,
    height: 2.46,
    transform: "translate(-53.88 53.76) rotate(-11.04)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.44,
    y: 302.57,
    width: 5.52,
    height: 2.46,
    transform: "translate(-53.38 55.47) rotate(-11.04)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,85.27A15.24,15.24,0,1,1,224,79.69,15.23,15.23,0,0,1,244.84,85.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,91.55c.47.81,1.42.76,2.57.48l-1.74-3C227.53,89.9,227.37,90.8,227.8,91.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.15,93.64l1.74,3c1.13-.9,1.32-1.78.9-2.51S234.34,93.34,233.15,93.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.14,81.62a13,13,0,1,0,17.77,4.76A13,13,0,0,0,225.14,81.62ZM236,98.49l1.1,1.91-1.39.8-1.09-1.88a8.68,8.68,0,0,1-5,1l-.23-2.16a7.46,7.46,0,0,0,4.14-.67l-2-3.39c-2.14.63-4.52,1.18-5.88-1.18-1-1.73-.61-4,1.89-5.75l-1.11-1.91,1.39-.81,1.09,1.89a8.43,8.43,0,0,1,4-1l.3,2.12a8,8,0,0,0-3.28.67l2,3.43c2.14-.63,4.54-1.22,5.9,1.14C238.87,94.46,238.46,96.69,236,98.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.99,
    cy: 229.72,
    r: 15.24,
    transform: "translate(-48.38 123.21) rotate(-16.38)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,228.38c.47.82,1.42.77,2.57.49l-1.75-3C399.88,226.73,399.72,227.64,400.15,228.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.5,230.48l1.73,3c1.13-.9,1.33-1.78.91-2.51S406.68,230.18,405.5,230.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,218.46a13,13,0,1,0,17.76,4.76A13,13,0,0,0,397.49,218.46Zm10.81,16.87,1.1,1.9L408,238l-1.09-1.89a8.52,8.52,0,0,1-5,1l-.23-2.15a7.57,7.57,0,0,0,4.14-.67l-2-3.4c-2.15.63-4.52,1.19-5.88-1.17-1-1.73-.62-4,1.88-5.75l-1.1-1.92,1.39-.8,1.09,1.88a8.39,8.39,0,0,1,4-.95l.29,2.12a8,8,0,0,0-3.27.67l2,3.42c2.15-.62,4.55-1.22,5.91,1.14C411.22,231.29,410.81,233.52,408.3,235.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 260.06,
    cy: 376.63,
    r: 15.24,
    transform: "translate(-58.59 48.09) rotate(-9.5)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46,372.82c-.82.45-.79,1.4-.53,2.55l3.05-1.69C263.11,372.57,262.21,372.4,261.46,372.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.27,378.13l-3,1.68c.89,1.15,1.76,1.36,2.5.95S259.55,379.32,259.27,378.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.43,370.32A13,13,0,1,0,266.37,388,13,13,0,0,0,271.43,370.32Zm-17.05,10.53-1.92,1.07-.78-1.41,1.9-1.05a8.56,8.56,0,0,1-.91-5l2.16-.19a7.55,7.55,0,0,0,.6,4.15l3.42-1.9c-.59-2.16-1.1-4.54,1.28-5.87,1.75-1,4-.55,5.71,2l1.94-1.07.78,1.4-1.9,1.06a8.42,8.42,0,0,1,.88,4.06l-2.12.26a8,8,0,0,0-.61-3.29L261.35,377c.59,2.16,1.14,4.56-1.24,5.89C258.36,383.84,256.14,383.39,254.38,380.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 95.49,
    cy: 329.32,
    r: 15.24,
    transform: "translate(-88.97 40.28) rotate(-16.38)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.65,328c.47.82,1.41.77,2.57.49l-1.75-3C91.38,326.33,91.22,327.24,91.65,328Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,330.08l1.73,3c1.13-.9,1.33-1.78.91-2.51S98.18,329.78,97,330.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,318.06a13,13,0,1,0,17.76,4.76A13,13,0,0,0,89,318.06ZM99.8,334.93l1.1,1.9-1.39.81-1.09-1.89a8.52,8.52,0,0,1-5,1l-.23-2.15a7.58,7.58,0,0,0,4.14-.67l-2-3.39c-2.15.62-4.52,1.18-5.88-1.18-1-1.73-.62-4,1.88-5.75l-1.1-1.92,1.39-.8,1.09,1.88a8.51,8.51,0,0,1,4-.95l.29,2.12a8,8,0,0,0-3.28.67l2,3.42c2.15-.62,4.55-1.22,5.91,1.14C102.72,330.89,102.31,333.12,99.8,334.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.26,
    cy: 203.68,
    r: 23.74,
    transform: "translate(-2.72 3.28) rotate(-0.77)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.08,200c.35,1.42,1.79,1.75,3.64,1.82l-1.33-5.27C237.37,197.45,236.75,198.73,237.08,200Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.2,205.46l1.31,5.24c2.08-.86,2.75-2.1,2.43-3.37C247.57,205.87,246.1,205.52,244.2,205.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.33,184a20.26,20.26,0,1,0,24.58,14.73A20.26,20.26,0,0,0,237.33,184Zm9,29.9.83,3.32-2.43.61-.82-3.29a13.33,13.33,0,0,1-7.87-.64l.58-3.32a11.71,11.71,0,0,0,6.49.76l-1.49-5.92c-3.48,0-7.28-.16-8.31-4.28-.75-3,.78-6.2,5.29-7.8l-.84-3.35,2.43-.61.82,3.29a13,13,0,0,1,6.46.3l-.46,3.29a12.63,12.63,0,0,0-5.2-.39l1.5,6c3.49,0,7.33.11,8.36,4.23C252.42,209.13,250.85,212.29,246.32,213.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.11,138.93a20.87,20.87,0,1,1-1.71-29.47A20.87,20.87,0,0,1,156.11,138.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,119.49c-.85,1-.38,2.17.48,3.54l3.17-3.56C142.63,118.42,141.39,118.61,140.6,119.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,127.34,137,130.89c1.66,1.09,2.89,1,3.65.09S141.09,128.76,140.19,127.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,111.75a17.81,17.81,0,1,0,1.47,25.15A17.8,17.8,0,0,0,152.36,111.75Zm-17.28,21.33-2,2.24-1.64-1.46,2-2.22a11.75,11.75,0,0,1-3.43-6l2.7-1.22a10.36,10.36,0,0,0,2.66,5.09l3.57-4c-1.75-2.52-3.49-5.37-1-8.15,1.82-2,4.89-2.51,8.29,0l2-2.27,1.64,1.47-2,2.22a11.52,11.52,0,0,1,3,4.85l-2.62,1.29a11.05,11.05,0,0,0-2.29-4l-3.6,4c1.74,2.52,3.54,5.38,1.06,8.17C141.59,135.13,138.52,135.56,135.08,133.08Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-30"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-30",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398,392.61s1.39-10.17,7.89-11.28,4.55-6,6.24-7.94,6.13,3.71,2.33,9.15-.69,3.74-2.33,8.8S397.36,401.05,398,392.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,392.61s1.39-10.17,7.89-11.28,4.55-6,6.24-7.94,6.13,3.71,2.33,9.15-.69,3.74-2.33,8.8S397.36,401.05,398,392.61Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,399.56a.45.45,0,0,1-.42-.61c0-.11,4-10.81.16-27.11a69.17,69.17,0,0,0-5-13.56c-3.76-8.16-7-15.2-2.19-28.35,1.48-4.06,3-7.86,4.52-11.53,5.51-13.54,9.87-24.24,5.27-34.14a.46.46,0,0,1,.22-.6.44.44,0,0,1,.6.22c4.76,10.25.34,21.11-5.25,34.86-1.49,3.66-3,7.45-4.52,11.5-4.68,12.8-1.66,19.35,2.17,27.66a70.86,70.86,0,0,1,5.1,13.73c3.95,16.59-.16,27.54-.2,27.65A.44.44,0,0,1,400.12,399.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,397.19s4.2-6.34-1.87-9.6-7.28-.64-11-3-6.6-8-7.24-4.39,3.7,5.71,2.16,7.37S394.21,400,402,397.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,289.2s3.09-12.74-6.22-12.26S400.67,288.22,405,289.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,299.39s-3.67-11.07-10.08-8.16S391.17,300.13,397.73,299.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,299.47s-1.71-8.93,5.27-9.67S418.76,297.23,409,299.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,318.22s8.72-9.12,12.6-3.16S411.93,323.15,405.81,318.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,318.07s-2.88-13.76-10.12-8.8S382.58,320,389.08,318.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,338.51s4.47-14.5-5.8-12.08S376.38,335.69,384,338.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,342.24s7.95-11.06,14.93-8.31S417.62,347.4,400.37,342.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.23,365.81s-8.82-16-15-9.88S384.57,369.56,394.23,365.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,364s-3-12.74,4.48-12.3S415.69,360.16,405,364Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405,289.2s3.09-12.74-6.22-12.26S400.67,288.22,405,289.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.73,299.39s-3.67-11.07-10.08-8.16S391.17,300.13,397.73,299.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,299.47s-1.71-8.93,5.27-9.67S418.76,297.23,409,299.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.81,318.22s8.72-9.12,12.6-3.16S411.93,323.15,405.81,318.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.08,318.07s-2.88-13.76-10.12-8.8S382.58,320,389.08,318.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,338.51s4.47-14.5-5.8-12.08S376.38,335.69,384,338.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.37,342.24s7.95-11.06,14.93-8.31S417.62,347.4,400.37,342.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.23,365.81s-8.82-16-15-9.88S384.57,369.56,394.23,365.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405,364s-3-12.74,4.48-12.3S415.69,360.16,405,364Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M402.34,306.54h-.09a.47.47,0,0,1-.29-.2c0-.07-4.14-6.6-6.95-8a.45.45,0,0,1,.4-.81c2.64,1.31,6.1,6.43,7.06,7.92a33,33,0,0,0,8.22-9.34.45.45,0,0,1,.79.44c-.15.26-3.64,6.4-8.89,9.91A.44.44,0,0,1,402.34,306.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.21,324.47h0a.43.43,0,0,1-.32-.19c0-.07-5.08-7.15-11-10a.46.46,0,0,1,.4-.82c5.4,2.63,9.91,8.35,11.08,9.94,7.55-6.45,17.55-7,17.65-7a.46.46,0,0,1,.47.43.44.44,0,0,1-.42.47c-.1,0-10.13.56-17.47,7.1A.46.46,0,0,1,395.21,324.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.61,347.7a.41.41,0,0,1-.25-.08c-6-4-11.15-14.87-11.36-15.33a.45.45,0,0,1,.21-.6.44.44,0,0,1,.6.22c.05.1,5.15,10.75,10.81,14.79,1.75-1.18,11.56-7.58,19.42-8.36a.46.46,0,0,1,.49.4.45.45,0,0,1-.4.5c-8.25.82-19.15,8.31-19.26,8.38A.42.42,0,0,1,391.61,347.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.12,370.74a.41.41,0,0,1-.34-.16,24.8,24.8,0,0,0-13-7,.44.44,0,0,1-.34-.54.44.44,0,0,1,.53-.34,25.82,25.82,0,0,1,13.2,7c3.84-3,8.35-13.82,8.4-13.93a.44.44,0,0,1,.59-.24.45.45,0,0,1,.24.59c-.2.48-4.91,11.75-9,14.56A.42.42,0,0,1,400.12,370.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.34,395.67s3.61-5.74,7.68-6.55,5.83-5.51,7.33-2.69S413.71,398.6,401.34,395.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.06 418.2 380.68 418.2 378.04 393.92 422.69 393.92 420.06 418.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.61 398.52 377.12 398.52 376.53 393.37 424.2 393.37 423.61 398.52",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.61 398.52 377.12 398.52 376.53 393.37 424.2 393.37 423.61 398.52",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Banknotes--inject-30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.27,
    y: 260.68,
    width: 192.17,
    height: 92.82,
    transform: "translate(33.33 629.92) rotate(-129.46)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.25 351.79 242.14 368.33 204.28 399.5 190.59 410.77 176.24 393.32 150.73 362.34 68.46 262.39 82.64 250.71 101.98 234.81 140.13 203.41 151.76 217.55 255.46 343.54 262.25 351.79",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.16,298.72l2.73-2.25,1.66,2-2.72,2.24c1.83,2.51,3,5.48,2.9,7.66l-3.37.93a12.18,12.18,0,0,0-2.17-6.42l-4.89,4c1.57,3.25,3.09,6.89-.31,9.69-2.5,2-6.16,2-9.67-1.48l-2.76,2.27-1.65-2,2.71-2.24A13.55,13.55,0,0,1,153,307l3.29-1a13.15,13.15,0,0,0,1.94,5.05l4.94-4.07c-1.57-3.25-3.15-6.92.25-9.72C165.94,295.14,169.6,295.2,173.16,298.72Zm-8.82,10.62L160,312.92c1.69,1.52,3.18,1.53,4.25.64S165.09,311.1,164.34,309.34Zm1.9-9.2c-1.19,1-.87,2.53-.08,4.34l4.33-3.56C168.75,299.35,167.3,299.28,166.24,300.14Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.49,342.14,146.75,219.74a10.68,10.68,0,0,1-15.05-1.46l-47,38.7a10.69,10.69,0,0,1-1.46,15L184,394.43a10.69,10.69,0,0,1,15,1.46l47-38.7A10.69,10.69,0,0,1,247.49,342.14ZM105,282.86a2.45,2.45,0,0,1-3.45-.34l-6.8-8.26a2.45,2.45,0,0,1,.34-3.45h0a2.45,2.45,0,0,1,3.45.34l6.8,8.26A2.45,2.45,0,0,1,105,282.86Zm73.37,40.07a20.52,20.52,0,1,1,2.8-28.88A20.53,20.53,0,0,1,178.4,322.93Zm57.2,20.44a2.45,2.45,0,0,1-3.45-.34l-6.8-8.26a2.45,2.45,0,1,1,3.78-3.12l6.8,8.27A2.46,2.46,0,0,1,235.6,343.37Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.46 343.54 176.24 393.32 150.73 362.34 82.64 250.71 101.98 234.81 151.76 217.55 255.46 343.54",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.24,
    y: 238.3,
    width: 192.17,
    height: 92.82,
    transform: "translate(1.77 570.44) rotate(-120.07)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.63 344.61 173.31 391.11 165.79 378.13 146.44 344.72 77.02 224.81 100.11 211.44 118.5 200.79 157.34 178.3 166.37 193.9 252.74 343.08 253.63 344.61",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.38,277.73l3.08-1.78,1.3,2.25-3,1.76c1.39,2.78,2,5.89,1.62,8l-3.49.37a12.11,12.11,0,0,0-1.09-6.69l-5.48,3.17c1,3.48,1.92,7.31-1.89,9.52-2.79,1.62-6.41,1-9.29-3l-3.1,1.79-1.3-2.24,3-1.77a13.63,13.63,0,0,1-1.55-6.53l3.42-.48a13,13,0,0,0,1.09,5.3l5.54-3.21c-1-3.47-2-7.34,1.83-9.54C167.85,273,171.45,273.68,174.38,277.73Zm-10.43,9-4.88,2.82c1.43,1.77,2.9,2,4.1,1.33S164.41,288.63,164,286.77Zm3.38-8.77c-1.34.78-1.27,2.35-.78,4.26l4.85-2.8C169.94,277.63,168.51,277.32,167.33,278Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M240.64,332.69,161.21,195.5a10.68,10.68,0,0,1-14.6-3.9L93.9,222.12A10.68,10.68,0,0,1,90,236.72l79.43,137.2a10.69,10.69,0,0,1,14.61,3.89l52.7-30.51A10.69,10.69,0,0,1,240.64,332.69ZM109.76,251a2.45,2.45,0,0,1-3.35-.89l-5.36-9.26a2.45,2.45,0,0,1,.89-3.35h0a2.45,2.45,0,0,1,3.35.89l5.36,9.27A2.44,2.44,0,0,1,109.76,251Zm65.85,51.51a20.52,20.52,0,1,1,7.47-28A20.53,20.53,0,0,1,175.61,302.47ZM228.71,332a2.45,2.45,0,0,1-3.35-.9L220,321.8a2.45,2.45,0,1,1,4.24-2.45l5.36,9.26A2.45,2.45,0,0,1,228.71,332Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "252.74 343.08 165.79 378.13 146.44 344.72 100.11 211.44 118.5 200.79 166.37 193.9 252.74 343.08",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.2,
    y: 220.73,
    width: 192.17,
    height: 92.82,
    transform: "translate(-22.85 517.98) rotate(-109.01)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.2,
    y: 220.73,
    width: 192.17,
    height: 92.82,
    transform: "translate(-22.85 517.98) rotate(-109.01)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.52,262l3.35-1.15.85,2.45-3.33,1.15c.83,3,.86,6.17,0,8.19l-3.48-.3a12.25,12.25,0,0,0,.21-6.78l-6,2.07c.34,3.6.48,7.54-3.68,9-3.05,1.05-6.48-.25-8.54-4.76L159.57,273l-.85-2.45,3.32-1.15a13.63,13.63,0,0,1-.26-6.71l3.44.19a13.09,13.09,0,0,0,.06,5.41l6.05-2.09c-.34-3.6-.54-7.58,3.62-9C178,256.15,181.42,257.49,183.52,262Zm-12,6.88-5.33,1.83c1.07,2,2.45,2.54,3.77,2.09S171.63,270.81,171.54,268.9Zm5-8c-1.46.51-1.7,2.06-1.59,4l5.3-1.82C179.17,261.08,177.83,260.5,176.54,260.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238,328.68,186.37,178.8a10.69,10.69,0,0,1-13.59-6.63L115.2,192a10.69,10.69,0,0,1-6.63,13.59L160.2,355.48a10.69,10.69,0,0,1,13.59,6.63l57.58-19.84A10.69,10.69,0,0,1,238,328.68ZM125.23,223.36a2.46,2.46,0,0,1-3.12-1.52l-3.48-10.11a2.46,2.46,0,0,1,1.52-3.12h0a2.45,2.45,0,0,1,3.11,1.52l3.49,10.12A2.45,2.45,0,0,1,125.23,223.36ZM180,286.54a20.52,20.52,0,1,1,12.72-26.08A20.51,20.51,0,0,1,180,286.54Zm46.46,39.13a2.46,2.46,0,0,1-3.12-1.52L219.83,314a2.45,2.45,0,1,1,4.63-1.59l3.48,10.12A2.43,2.43,0,0,1,226.43,325.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.92,387.39A24.67,24.67,0,0,1,119,365.94a24.62,24.62,0,0,1,30.9,21.45Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 178.77,
    cy: 321.92,
    r: 24.63,
    transform: "translate(-130.75 122.44) rotate(-28.15)",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.14,368.33,204.28,399.5a24.63,24.63,0,1,1,37.86-31.17Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coins--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185,412.09v4.57a1.49,1.49,0,0,1-.45,1.08,1.77,1.77,0,0,1-.23.19,1.54,1.54,0,0,1-.87.27H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.67,1.67,0,0,1-.16-.12l-.12-.12h0a.72.72,0,0,1-.11-.15l-.05-.08,0,0a.24.24,0,0,1-.07-.13l0,0s0-.07,0-.11a.09.09,0,0,1,0,0s0,0,0-.05,0-.08,0-.12,0,0,0,0a1.25,1.25,0,0,1,0-.21v-4.61a1.5,1.5,0,0,1,1.54-1.53h47.35a1.55,1.55,0,0,1,.31,0h.06a.78.78,0,0,1,.23.08l.07,0,.16.09,0,0,.18.15.07.06.1.14a.66.66,0,0,1,.12.17.16.16,0,0,0,0,.07,1.08,1.08,0,0,1,.08.19.67.67,0,0,1,.07.24A2.46,2.46,0,0,1,185,412.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,412.09v4.57a1.54,1.54,0,0,1-.44,1.08,1.77,1.77,0,0,1-.23.19,1.54,1.54,0,0,1-.87.27H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.67,1.67,0,0,1-.16-.12l-.12-.12h0a.83.83,0,0,1-.08-.12l0,0-.05-.08,0-.07s0,0,0,0a.67.67,0,0,0-.06-.12s0-.07,0-.11l0-.1s0-.08,0-.12,0,0,0,0a1.25,1.25,0,0,1,0-.21v-4.61A1.58,1.58,0,0,1,135,411a1.55,1.55,0,0,1,1.1-.45h47.35l.23,0,.08,0h.09a.84.84,0,0,1,.2.08.11.11,0,0,1,.07,0l.18.09,0,0,.18.15.07.06.1.14a.66.66,0,0,1,.12.17.16.16,0,0,0,0,.07,1.08,1.08,0,0,1,.08.19,1.68,1.68,0,0,1,.07.24C185,411.92,185,412,185,412.09Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,410.79H146.78a.94.94,0,0,0-.94.95v5a.85.85,0,0,1-.85.85H134.87l0,0-.05-.08,0,0,0,0s0,0,0,0l0-.08,0,0s0-.07,0-.11a.09.09,0,0,1,0,0,.47.47,0,0,1,0-.17s0,0,0,0a1.25,1.25,0,0,1,0-.21v-4.61A1.58,1.58,0,0,1,135,411a1.55,1.55,0,0,1,1.1-.45h47.35l.23,0,.08,0h.09a.84.84,0,0,1,.2.08.11.11,0,0,1,.07,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,412.09v4.57a1.54,1.54,0,0,1-.44,1.08,1.77,1.77,0,0,1-.23.19,1.54,1.54,0,0,1-.87.27H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2h37.51a.94.94,0,0,0,.94-.94v-5a.85.85,0,0,1,.85-.85h10.12a.66.66,0,0,1,.12.17.16.16,0,0,0,0,.07,1.08,1.08,0,0,1,.08.19,1.68,1.68,0,0,1,.07.24C185,411.92,185,412,185,412.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.13,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,137.13,417.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.65,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,139.65,417.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,142.16,417.33Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,144.68,417.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.19,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,147.19,417.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,149.71,417.33Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,152.22,417.33Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M154.74,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,154.74,417.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.25,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,157.25,417.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M159.77,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,159.77,417.33Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28,417.33a.23.23,0,0,1-.23-.23v-5.45a.23.23,0,0,1,.23-.24.24.24,0,0,1,.24.24v5.45A.23.23,0,0,1,162.28,417.33Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,164.8,417.33Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M167.31,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,167.31,417.33Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.83,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,169.83,417.33Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M172.34,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,172.34,417.33Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.86,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,174.86,417.33Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M177.38,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,177.38,417.33Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.89,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,179.89,417.33Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M182.41,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,182.41,417.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186,404.49v4.56a1.51,1.51,0,0,1-.46,1.09,1.55,1.55,0,0,1-1.1.45H136.81l-.13,0h0a1.3,1.3,0,0,1-.43-.2h0a1.11,1.11,0,0,1-.23-.19.67.67,0,0,1-.14-.16l0,0,0-.06,0,0a.39.39,0,0,1-.1-.16s0,0,0,0l0-.1a.09.09,0,0,1,0-.05s0,0,0-.06a.43.43,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.61a1.51,1.51,0,0,1,.27-.86.83.83,0,0,1,.19-.23,1.43,1.43,0,0,1,.68-.4h0a1.5,1.5,0,0,1,.37-.05h47.35l.23,0h0l.12,0h.05a.08.08,0,0,1,.07,0,.06.06,0,0,1,.05,0H185a1,1,0,0,1,.25.13,1,1,0,0,1,.19.15l.08.08a.64.64,0,0,1,.1.13l.13.17a.16.16,0,0,0,0,.07c0,.07.05.12.07.19a.72.72,0,0,1,.07.25A1.09,1.09,0,0,1,186,404.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94,404.49v4.56a1.54,1.54,0,0,1-1.55,1.54H136.81l-.13,0h0a1.3,1.3,0,0,1-.43-.2h0a1.11,1.11,0,0,1-.23-.19.67.67,0,0,1-.14-.16l0,0,0-.06a.61.61,0,0,1-.07-.1.93.93,0,0,0-.05-.1s0,0,0,0l0-.1a.76.76,0,0,1,0-.11.43.43,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.61a1.51,1.51,0,0,1,.27-.86.83.83,0,0,1,.19-.23,1.43,1.43,0,0,1,.68-.4h0a1.5,1.5,0,0,1,.37-.05h47.35l.23,0h0l.12,0h.08l0,0h.05l0,0h0a1,1,0,0,1,.25.13,1,1,0,0,1,.19.15l.08.08a.64.64,0,0,1,.1.13l.13.17a.16.16,0,0,0,0,.07c0,.07.05.12.07.19a1.82,1.82,0,0,1,.07.25A2.11,2.11,0,0,1,185.94,404.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.24,403.19h-37.5a.94.94,0,0,0-1,.94v5a.85.85,0,0,1-.84.85H135.82l0,0,0-.06,0,0-.05-.06a.93.93,0,0,0-.05-.1s0,0,0,0l0-.1a.09.09,0,0,1,0-.05.64.64,0,0,1-.05-.17v0a1.49,1.49,0,0,1,0-.21v-4.61a1.51,1.51,0,0,1,.27-.86.83.83,0,0,1,.19-.23,1.43,1.43,0,0,1,.68-.4h0a1.5,1.5,0,0,1,.37-.05h47.35l.23,0h0l.12,0h.08l0,0h.05l.06,0A1,1,0,0,1,185.24,403.19Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.94,404.49v4.56a1.54,1.54,0,0,1-1.55,1.54H136.81l-.13,0h0a1.3,1.3,0,0,1-.43-.2H173.7a.94.94,0,0,0,.94-.95v-5a.85.85,0,0,1,.85-.85h10.12l.13.17a.16.16,0,0,0,0,.07c0,.07.05.12.07.19a1.82,1.82,0,0,1,.07.25A2.11,2.11,0,0,1,185.94,404.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.08,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,138.08,409.72Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M140.6,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,140.6,409.72Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.11,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,143.11,409.72Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M145.63,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,145.63,409.72Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M148.14,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,148.14,409.72Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M150.66,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,150.66,409.72Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M153.18,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,153.18,409.72Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M155.69,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,155.69,409.72Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.21,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,158.21,409.72Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M160.72,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,160.72,409.72Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.24,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,163.24,409.72Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M165.75,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,165.75,409.72Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M168.27,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,168.27,409.72Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M170.78,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,170.78,409.72Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M173.3,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,173.3,409.72Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M175.81,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,175.81,409.72Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M178.33,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,178.33,409.72Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M180.84,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,180.84,409.72Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M183.36,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,183.36,409.72Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185,396.87v4.57a1.53,1.53,0,0,1-.12.6h0a1.39,1.39,0,0,1-.32.48,1.58,1.58,0,0,1-.73.4,1.44,1.44,0,0,1-.37.05H136.09a1.63,1.63,0,0,1-.31,0,2.46,2.46,0,0,1-.29-.09.65.65,0,0,1-.23-.13l0,0-.21-.16a1.24,1.24,0,0,1-.14-.18l0-.05,0,0a0,0,0,0,1,0,0,.56.56,0,0,1-.11-.2.54.54,0,0,1-.05-.11.53.53,0,0,1,0-.17s0,0,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.17-1.5,2.1,2.1,0,0,1,.37,0h47.35l.23,0h0l.11,0h.06a.08.08,0,0,1,.07,0s0,0,0,0H184l.25.13.19.16.08.07a.9.9,0,0,1,.23.33l0,0c0,.07.07.15.09.21A1.23,1.23,0,0,1,185,396.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,396.88v4.56a1.52,1.52,0,0,1-.11.6h0a1.61,1.61,0,0,1-.32.48,1.53,1.53,0,0,1-.7.4,1.29,1.29,0,0,1-.4.06H136.09a1.06,1.06,0,0,1-.31,0,2.46,2.46,0,0,1-.29-.09,1.19,1.19,0,0,1-.25-.13s0,0,0,0l-.21-.16a1.24,1.24,0,0,1-.14-.18l0-.05,0,0-.06-.09s0,0,0,0a1.15,1.15,0,0,1-.1-.23.53.53,0,0,1,0-.17s0,0,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.17-1.5,2.1,2.1,0,0,1,.37,0h47.35l.23,0h0l.11,0h.09l0,0h0l.05,0h0l.25.13.19.16.08.07.1.14a.64.64,0,0,1,.13.19l0,0c0,.07.07.15.09.21A1.47,1.47,0,0,1,185,396.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,395.58H146.78a.94.94,0,0,0-.94.95v5a.85.85,0,0,1-.85.85H134.87l0-.05,0,0a0,0,0,0,1,0,0l0-.06s0,0,0,0l0-.12a.54.54,0,0,1-.05-.11.53.53,0,0,1,0-.17s0,0,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.17-1.5,2.1,2.1,0,0,1,.37,0h47.35l.23,0h0l.11,0h.09l0,0h0l.07,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,396.88v4.56a1.52,1.52,0,0,1-.11.6h0a1.61,1.61,0,0,1-.32.48,1.53,1.53,0,0,1-.7.4,1.29,1.29,0,0,1-.4.06H136.09a1.06,1.06,0,0,1-.31,0,2.46,2.46,0,0,1-.29-.09,1.19,1.19,0,0,1-.25-.13h37.51a.94.94,0,0,0,.94-.94v-5a.85.85,0,0,1,.85-.84h10.12a.64.64,0,0,1,.13.19l0,0c0,.07.07.15.09.21A1.47,1.47,0,0,1,185,396.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M137.13,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,137.13,402.11Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.65,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,139.65,402.11Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,142.16,402.11Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,144.68,402.11Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M147.19,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,147.19,402.11Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,149.71,402.11Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,152.22,402.11Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154.74,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,154.74,402.11Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M157.25,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,157.25,402.11Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M159.77,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,159.77,402.11Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28,402.11a.23.23,0,0,1-.23-.23v-5.45a.23.23,0,0,1,.23-.24.24.24,0,0,1,.24.24v5.45A.23.23,0,0,1,162.28,402.11Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,164.8,402.11Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M167.31,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,167.31,402.11Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M169.83,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,169.83,402.11Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M172.34,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,172.34,402.11Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M174.86,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,174.86,402.11Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M177.38,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,177.38,402.11Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M179.89,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,179.89,402.11Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M182.41,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,182.41,402.11Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,389.26v4.57a1.55,1.55,0,0,1-1.17,1.5,2.22,2.22,0,0,1-.38,0H134.18l-.23,0a.41.41,0,0,1-.16,0,1.51,1.51,0,0,1-.45-.2,1.19,1.19,0,0,1-.37-.37l0,0s0,0,0,0a.09.09,0,0,1,0-.08.1.1,0,0,1,0,0,.08.08,0,0,1,0-.05l0-.06a.24.24,0,0,0,0-.08,0,0,0,0,0,0,0,.09.09,0,0,1,0-.05s0,0,0-.06a.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.62a1.5,1.5,0,0,1,.45-1.08,1.61,1.61,0,0,1,.84-.43h0a.65.65,0,0,1,.2,0h47.35a.68.68,0,0,1,.21,0h.11l.28.09.07,0a.62.62,0,0,1,.16.1l0,0a.62.62,0,0,1,.18.14.46.46,0,0,0,.07.07.64.64,0,0,1,.1.13,1.71,1.71,0,0,0,.11.14.89.89,0,0,1,.08.17.08.08,0,0,1,0,.05.52.52,0,0,1,.06.16A1.45,1.45,0,0,1,183.08,389.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,389.26v4.57a1.55,1.55,0,0,1-1.17,1.5,2.22,2.22,0,0,1-.38,0H134.18l-.23,0a.41.41,0,0,1-.16,0,1.51,1.51,0,0,1-.45-.2,1.19,1.19,0,0,1-.37-.37l0,0s0,0,0,0l-.08-.13a.24.24,0,0,1-.06-.11.24.24,0,0,0,0-.08,0,0,0,0,0,0,0,.76.76,0,0,1,0-.11.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.62a1.5,1.5,0,0,1,.45-1.08,1.52,1.52,0,0,1,.81-.43h0a1.07,1.07,0,0,1,.25,0h47.35l.23,0h.09a1.31,1.31,0,0,1,.28.09.11.11,0,0,1,.07,0,.64.64,0,0,1,.18.1l0,0a.62.62,0,0,1,.18.14.46.46,0,0,0,.07.07.64.64,0,0,1,.1.13,1.71,1.71,0,0,0,.11.14.89.89,0,0,1,.08.17.08.08,0,0,1,0,.05.52.52,0,0,1,.06.16A1.45,1.45,0,0,1,183.08,389.26Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,388h-37.5a.94.94,0,0,0-.95.94v5a.85.85,0,0,1-.84.84H133l0,0a.75.75,0,0,1-.07-.12.1.1,0,0,1,0,0,.08.08,0,0,1,0-.05.84.84,0,0,1-.06-.14,0,0,0,0,0,0,0,.09.09,0,0,1,0-.05.64.64,0,0,1-.05-.17v0a1.49,1.49,0,0,1,0-.21v-4.62a1.5,1.5,0,0,1,.45-1.08,1.52,1.52,0,0,1,.81-.43h0a1.07,1.07,0,0,1,.25,0h47.35l.23,0h.09a1.31,1.31,0,0,1,.28.09.11.11,0,0,1,.07,0A.64.64,0,0,1,182.38,388Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,389.26v4.57a1.55,1.55,0,0,1-1.17,1.5,2.22,2.22,0,0,1-.38,0H134.18l-.23,0a.41.41,0,0,1-.16,0,1.51,1.51,0,0,1-.45-.2h37.5a.94.94,0,0,0,.94-.95v-5a.86.86,0,0,1,.85-.85h10.12a1.71,1.71,0,0,0,.11.14.89.89,0,0,1,.08.17.08.08,0,0,1,0,.05.52.52,0,0,1,.06.16A1.45,1.45,0,0,1,183.08,389.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M135.22,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,135.22,394.5Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,137.74,394.5Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,140.25,394.5Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M142.77,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,142.77,394.5Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M145.28,394.5a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,145.28,394.5Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.8,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,147.8,394.5Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M150.31,394.5a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,150.31,394.5Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M152.83,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,152.83,394.5Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M155.35,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,155.35,394.5Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M157.86,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,157.86,394.5Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M160.38,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,160.38,394.5Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M162.89,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,162.89,394.5Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M165.41,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,165.41,394.5Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M167.92,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,167.92,394.5Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M170.44,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,170.44,394.5Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M173,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,173,394.5Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,175.47,394.5Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M178,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,178,394.5Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,180.5,394.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,381.66v4.56a1.53,1.53,0,0,1-.45,1.09,1.61,1.61,0,0,1-.84.43h0a.68.68,0,0,1-.21,0H134.18a.65.65,0,0,1-.2,0h-.11a1.66,1.66,0,0,1-.29-.1.48.48,0,0,1-.22-.12l0,0a1.16,1.16,0,0,1-.21-.16.59.59,0,0,1-.14-.18l0,0s0,0,0,0a.09.09,0,0,1,0-.05.56.56,0,0,1-.09-.17.43.43,0,0,1-.05-.12,1.09,1.09,0,0,1,0-.17s0-.05,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.54h47.6l.12,0h0l.07,0s0,0,0,0h.06l.25.13a1,1,0,0,1,.19.16l.08.07a1.13,1.13,0,0,1,.1.13,1,1,0,0,1,.11.17.21.21,0,0,1,.06.1l.06.14a.14.14,0,0,1,0,.07.61.61,0,0,1,.05.18A1.27,1.27,0,0,1,183.08,381.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,381.66v4.56a1.53,1.53,0,0,1-.45,1.09,1.56,1.56,0,0,1-.81.43h0l-.27,0H134.18a1.07,1.07,0,0,1-.25,0h-.06a1.66,1.66,0,0,1-.29-.1.77.77,0,0,1-.24-.12l0,0a1.16,1.16,0,0,1-.21-.16.59.59,0,0,1-.14-.18l0,0s0,0,0,0l-.08-.12a1,1,0,0,1-.09-.22,1.09,1.09,0,0,1,0-.17s0-.05,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.54h47.6l.12,0H182l0,0h0l.05,0h0l.25.13a1,1,0,0,1,.19.16l.08.07a1.13,1.13,0,0,1,.1.13,1,1,0,0,1,.11.17.21.21,0,0,1,.06.1l.06.14a.14.14,0,0,1,0,.07.61.61,0,0,1,.05.18A1.27,1.27,0,0,1,183.08,381.66Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,380.36h-37.5a.94.94,0,0,0-.95.95v5a.85.85,0,0,1-.84.85H133l0,0a.47.47,0,0,1-.06-.09l-.05-.07a1,1,0,0,1,0-.1.43.43,0,0,1-.05-.12,1.09,1.09,0,0,1,0-.17s0-.05,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.54h47.6l.12,0H182l0,0h0l.06,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.08,381.66v4.56a1.53,1.53,0,0,1-.45,1.09,1.56,1.56,0,0,1-.81.43h0l-.27,0H134.18a1.07,1.07,0,0,1-.25,0h-.06a1.66,1.66,0,0,1-.29-.1.77.77,0,0,1-.24-.12h37.5a.94.94,0,0,0,.94-.94v-5a.86.86,0,0,1,.85-.85h10.12a1,1,0,0,1,.11.17.21.21,0,0,1,.06.1l.06.14a.14.14,0,0,1,0,.07.61.61,0,0,1,.05.18A1.27,1.27,0,0,1,183.08,381.66Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M135.22,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,135.22,386.9Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,137.74,386.9Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M140.25,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,140.25,386.9Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M142.77,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,142.77,386.9Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M145.28,386.9a.23.23,0,0,1-.23-.24v-5.45a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,145.28,386.9Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M147.8,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,147.8,386.9Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M150.31,386.9a.23.23,0,0,1-.23-.24v-5.45a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,150.31,386.9Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M152.83,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,152.83,386.9Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M155.35,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,155.35,386.9Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M157.86,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,157.86,386.9Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M160.38,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,160.38,386.9Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M162.89,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,162.89,386.9Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M165.41,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,165.41,386.9Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M167.92,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,167.92,386.9Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M170.44,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,170.44,386.9Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M173,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,173,386.9Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,175.47,386.9Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M178,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,178,386.9Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5,386.9a.24.24,0,0,1-.24-.24v-5.45a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,180.5,386.9Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186.9,374v4.57a1.55,1.55,0,0,1-1.55,1.54H138l-.24,0-.12,0h0a1.54,1.54,0,0,1-.47-.21h0a2.31,2.31,0,0,1-.24-.2.52.52,0,0,1-.13-.17l0,0,0-.05a.08.08,0,0,1,0,0,.43.43,0,0,1-.09-.16.52.52,0,0,1-.06-.16s0,0,0,0,0,0,0-.06a.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21V374a1.48,1.48,0,0,1,.27-.85,1.37,1.37,0,0,1,.19-.23,1.47,1.47,0,0,1,.72-.4,1.5,1.5,0,0,1,.37-.05h47.36l.3,0h.05l.25.08h0l0,0a.59.59,0,0,1,.17.1l0,0a.62.62,0,0,1,.19.14.19.19,0,0,0,.06.07.75.75,0,0,1,.11.13l.12.17a.16.16,0,0,0,0,.07.62.62,0,0,1,.07.19.66.66,0,0,1,.07.25A1.07,1.07,0,0,1,186.9,374Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,374v4.57a1.54,1.54,0,0,1-.45,1.09,1.51,1.51,0,0,1-1.09.45H138l-.24,0-.12,0h0a1.54,1.54,0,0,1-.47-.21h0a2.31,2.31,0,0,1-.24-.2.52.52,0,0,1-.13-.17l0,0,0-.05-.07-.1a.42.42,0,0,0,0-.1.52.52,0,0,1-.06-.16.36.36,0,0,1,0-.09.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21V374a1.48,1.48,0,0,1,.27-.85,1.37,1.37,0,0,1,.19-.23,1.35,1.35,0,0,1,.69-.4,1.25,1.25,0,0,1,.4-.06h47.35l.23,0,.08,0h.05l.25.08h0l0,0a.64.64,0,0,1,.18.1l0,0a.62.62,0,0,1,.19.14.19.19,0,0,0,.06.07.75.75,0,0,1,.11.13l.12.17a.16.16,0,0,0,0,.07.62.62,0,0,1,.07.19,1.49,1.49,0,0,1,.07.25A2.11,2.11,0,0,1,186.89,374Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.19,372.75h-37.5a.94.94,0,0,0-.94.94v5a.85.85,0,0,1-.85.84H136.78l0,0,0-.05a.08.08,0,0,1,0,0l-.05-.06a.42.42,0,0,0,0-.1.52.52,0,0,1-.06-.16s0,0,0,0a.64.64,0,0,1-.05-.17v0a1.49,1.49,0,0,1,0-.21V374a1.48,1.48,0,0,1,.27-.85,1.37,1.37,0,0,1,.19-.23,1.35,1.35,0,0,1,.69-.4,1.25,1.25,0,0,1,.4-.06h47.35l.23,0,.08,0h.05l.25.08h0l0,0A.64.64,0,0,1,186.19,372.75Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.89,374v4.57a1.54,1.54,0,0,1-.45,1.09,1.51,1.51,0,0,1-1.09.45H138l-.24,0-.12,0h0a1.54,1.54,0,0,1-.47-.21h37.49a.94.94,0,0,0,.95-.95v-5a.85.85,0,0,1,.84-.85h10.13l.12.17a.16.16,0,0,0,0,.07.62.62,0,0,1,.07.19,1.49,1.49,0,0,1,.07.25A2.11,2.11,0,0,1,186.89,374Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M139,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,139,379.29Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M141.55,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,141.55,379.29Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M144.07,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,144.07,379.29Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M146.58,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,146.58,379.29Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M149.1,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,149.1,379.29Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M151.61,379.29a.23.23,0,0,1-.23-.24V373.6a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,151.61,379.29Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M154.13,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,154.13,379.29Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M156.64,379.29a.23.23,0,0,1-.23-.24V373.6a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,156.64,379.29Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M159.16,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,159.16,379.29Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M161.68,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,161.68,379.29Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M164.19,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,164.19,379.29Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M166.71,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,166.71,379.29Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M169.22,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,169.22,379.29Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M171.74,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,171.74,379.29Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M174.25,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,174.25,379.29Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M176.77,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,176.77,379.29Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M179.28,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,179.28,379.29Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M181.8,379.29a.24.24,0,0,1-.24-.24V373.6a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,181.8,379.29Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M184.31,379.29a.23.23,0,0,1-.23-.24V373.6a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,184.31,379.29Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M185,366.43V371a1.46,1.46,0,0,1-.12.6h0a1.27,1.27,0,0,1-.32.49,1.53,1.53,0,0,1-.7.4h0a1.44,1.44,0,0,1-.37.05H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.58,1.58,0,0,1-.37-.36l0-.05,0,0a.06.06,0,0,1,0,0,.43.43,0,0,1-.11-.2.31.31,0,0,1-.05-.1.59.59,0,0,1,0-.17s0-.05,0-.08a2,2,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.55h47.35l.23,0h0l.11,0h.06a.08.08,0,0,1,.07,0s0,0,0,0H184l.25.13.19.15.08.08a1,1,0,0,1,.23.32l0,0c0,.07.07.15.09.21A1.23,1.23,0,0,1,185,366.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,366.44V371a1.44,1.44,0,0,1-.11.59h0a1.66,1.66,0,0,1-.32.49,1.53,1.53,0,0,1-.7.4h0a1.44,1.44,0,0,1-.37.05H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.58,1.58,0,0,1-.37-.36l0-.05,0,0-.06-.09s0,0,0,0a1.15,1.15,0,0,1-.1-.23.59.59,0,0,1,0-.17s0-.05,0-.08a2,2,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.55h47.35l.23,0h0l.11,0h.09l0,0h0l.05,0h0l.25.13.19.15.08.08a1.13,1.13,0,0,0,.1.13,1.07,1.07,0,0,1,.13.19l0,0c0,.07.07.15.09.21A1.44,1.44,0,0,1,185,366.44Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,365.14H146.78a.94.94,0,0,0-.94.95v5a.85.85,0,0,1-.85.85H134.87l0-.05,0,0a.06.06,0,0,1,0,0l0-.05s0,0,0,0a1.12,1.12,0,0,1,0-.13.31.31,0,0,1-.05-.1.59.59,0,0,1,0-.17s0-.05,0-.08a2,2,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.55h47.35l.23,0h0l.11,0h.09l0,0h0l.07,0Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,366.44V371a1.44,1.44,0,0,1-.11.59h0a1.66,1.66,0,0,1-.32.49,1.53,1.53,0,0,1-.7.4h0a1.44,1.44,0,0,1-.37.05H136.09l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2h37.51a.94.94,0,0,0,.94-.94v-5a.86.86,0,0,1,.85-.85h10.12a1.07,1.07,0,0,1,.13.19l0,0c0,.07.07.15.09.21A1.44,1.44,0,0,1,185,366.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M137.13,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,137.13,371.68Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M139.65,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,139.65,371.68Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M142.16,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,142.16,371.68Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,144.68,371.68Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M147.19,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,147.19,371.68Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M149.71,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,149.71,371.68Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,152.22,371.68Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M154.74,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,154.74,371.68Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M157.25,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,157.25,371.68Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M159.77,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,159.77,371.68Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M162.28,371.68a.23.23,0,0,1-.23-.24V366a.23.23,0,0,1,.23-.24.24.24,0,0,1,.24.24v5.45A.24.24,0,0,1,162.28,371.68Z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M164.8,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,164.8,371.68Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M167.31,371.68a.23.23,0,0,1-.23-.24V366a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,167.31,371.68Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M169.83,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,169.83,371.68Z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M172.34,371.68a.23.23,0,0,1-.23-.24V366a.24.24,0,1,1,.47,0v5.45A.24.24,0,0,1,172.34,371.68Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M174.86,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.48,0v5.45A.24.24,0,0,1,174.86,371.68Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M177.38,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,177.38,371.68Z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M179.89,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,0,1,.48,0v5.45A.24.24,0,0,1,179.89,371.68Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M182.41,371.68a.24.24,0,0,1-.24-.24V366a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,182.41,371.68Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 410.55,
    width: 50.44,
    height: 7.66,
    rx: 1.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,412.1v4.56a1.54,1.54,0,0,1-1.55,1.54H78.87A1.51,1.51,0,0,1,78,418a1.56,1.56,0,0,1-.7-1.29V412.1a1.55,1.55,0,0,1,1.54-1.56h47.35a1.49,1.49,0,0,1,1.22.62A1.47,1.47,0,0,1,127.77,412.1Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33,416.65v-4.56a1.54,1.54,0,0,1,1.54-1.55h47.35a1.58,1.58,0,0,1,.85.26H89.56a.94.94,0,0,0-.94.94v5a.85.85,0,0,1-.85.84H77.65A1.44,1.44,0,0,1,77.33,416.65Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,412.1v4.56a1.54,1.54,0,0,1-1.55,1.54H78.87A1.51,1.51,0,0,1,78,418h37.5a.94.94,0,0,0,.94-.95v-5a.85.85,0,0,1,.85-.85h10.12A1.47,1.47,0,0,1,127.77,412.1Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M79.91,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,79.91,417.33Z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M82.42,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,82.42,417.33Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M84.94,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,84.94,417.33Z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M87.45,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,87.45,417.33Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M90,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,90,417.33Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M92.49,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,92.49,417.33Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M95,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,95,417.33Z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M97.52,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,97.52,417.33Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M100,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,100,417.33Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M102.55,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,102.55,417.33Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M105.06,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,105.06,417.33Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M107.58,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,107.58,417.33Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M110.09,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,110.09,417.33Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M112.61,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,112.61,417.33Z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M115.12,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,115.12,417.33Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M117.64,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,117.64,417.33Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M120.15,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,120.15,417.33Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M122.67,417.33a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,122.67,417.33Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M125.18,417.33a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,125.18,417.33Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 70.65,
    y: 402.94,
    width: 50.44,
    height: 7.66,
    rx: 1.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09,404.49v4.56a1.54,1.54,0,0,1-1.54,1.54H72.2a1.54,1.54,0,0,1-.85-.25,1.56,1.56,0,0,1-.7-1.29v-4.56a1.55,1.55,0,0,1,1.55-1.56h47.35a1.52,1.52,0,0,1,1.22.62A1.47,1.47,0,0,1,121.09,404.49Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,409v-4.56a1.55,1.55,0,0,1,1.54-1.55h47.35a1.55,1.55,0,0,1,.85.26H82.89a.94.94,0,0,0-1,.94v5a.85.85,0,0,1-.84.85H71A1.49,1.49,0,0,1,70.65,409Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.09,404.49v4.56a1.54,1.54,0,0,1-1.54,1.54H72.2a1.54,1.54,0,0,1-.85-.25h37.5a.94.94,0,0,0,1-.95v-5a.85.85,0,0,1,.85-.85h10.12A1.47,1.47,0,0,1,121.09,404.49Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M73.23,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,73.23,409.72Z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M75.75,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,75.75,409.72Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M78.26,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,78.26,409.72Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M80.78,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,80.78,409.72Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M83.29,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,83.29,409.72Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M85.81,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,85.81,409.72Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M88.32,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,88.32,409.72Z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M90.84,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,90.84,409.72Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M93.36,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,93.36,409.72Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M95.87,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,95.87,409.72Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M98.39,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,98.39,409.72Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M100.9,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,100.9,409.72Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M103.42,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,103.42,409.72Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M105.93,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,105.93,409.72Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M108.45,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,108.45,409.72Z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M111,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,111,409.72Z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M113.48,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,113.48,409.72Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M116,409.72a.23.23,0,0,1-.23-.23V404a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,116,409.72Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M118.51,409.72a.23.23,0,0,1-.24-.23V404a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,118.51,409.72Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 77.32,
    y: 395.33,
    width: 50.44,
    height: 7.66,
    rx: 1.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,396.88v4.56a1.54,1.54,0,0,1-1.55,1.54H78.87a1.51,1.51,0,0,1-.84-.25,1.56,1.56,0,0,1-.7-1.29v-4.56a1.55,1.55,0,0,1,1.54-1.56h47.35a1.49,1.49,0,0,1,1.22.62A1.47,1.47,0,0,1,127.77,396.88Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.33,401.43v-4.56a1.54,1.54,0,0,1,1.54-1.55h47.35a1.58,1.58,0,0,1,.85.26H89.56a.94.94,0,0,0-.94.94v5a.86.86,0,0,1-.85.85H77.65A1.49,1.49,0,0,1,77.33,401.43Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.77,396.88v4.56a1.54,1.54,0,0,1-1.55,1.54H78.87a1.51,1.51,0,0,1-.84-.25h37.5a.94.94,0,0,0,.94-1v-5a.85.85,0,0,1,.85-.85h10.12A1.47,1.47,0,0,1,127.77,396.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M79.91,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,79.91,402.11Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M82.42,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,82.42,402.11Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M84.94,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,84.94,402.11Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M87.45,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,87.45,402.11Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M90,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,90,402.11Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M92.49,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,92.49,402.11Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M95,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,95,402.11Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M97.52,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,97.52,402.11Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M100,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,100,402.11Z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M102.55,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,102.55,402.11Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M105.06,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,105.06,402.11Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M107.58,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,107.58,402.11Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M110.09,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,110.09,402.11Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M112.61,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,112.61,402.11Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M115.12,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,115.12,402.11Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M117.64,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,117.64,402.11Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M120.15,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,120.15,402.11Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M122.67,402.11a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,122.67,402.11Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M125.18,402.11a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,125.18,402.11Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 75.42,
    y: 387.72,
    width: 50.44,
    height: 7.66,
    rx: 1.55,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,389.27v4.56a1.55,1.55,0,0,1-1.54,1.55H77a1.56,1.56,0,0,1-1.55-1.55v-4.56A1.55,1.55,0,0,1,77,387.71h47.35a1.57,1.57,0,0,1,1.54,1.56Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42,393.82v-4.56A1.55,1.55,0,0,1,77,387.71h47.35a1.55,1.55,0,0,1,.85.26H87.66a.94.94,0,0,0-1,.94v5a.86.86,0,0,1-.85.85H75.74A1.49,1.49,0,0,1,75.42,393.82Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.86,389.27v4.56a1.55,1.55,0,0,1-1.54,1.55H77a1.55,1.55,0,0,1-.85-.26h37.5a.94.94,0,0,0,.95-.95v-5a.85.85,0,0,1,.84-.85h10.13A1.52,1.52,0,0,1,125.86,389.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M78,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,78,394.5Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M80.52,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,80.52,394.5Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M83,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,83,394.5Z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M85.55,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,85.55,394.5Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M88.06,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,88.06,394.5Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M90.58,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,90.58,394.5Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M93.09,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,93.09,394.5Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M95.61,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,95.61,394.5Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M98.12,394.5a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,98.12,394.5Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M100.64,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,100.64,394.5Z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M103.15,394.5a.23.23,0,0,1-.23-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,103.15,394.5Z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M105.67,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,105.67,394.5Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M108.19,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,108.19,394.5Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M110.7,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,110.7,394.5Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M113.22,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.47,0v5.45A.23.23,0,0,1,113.22,394.5Z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M115.73,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,115.73,394.5Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M118.25,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.24-.24.24.24,0,0,1,.24.24v5.45A.23.23,0,0,1,118.25,394.5Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M120.76,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,1,1,.48,0v5.45A.23.23,0,0,1,120.76,394.5Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M123.28,394.5a.23.23,0,0,1-.24-.23v-5.45a.24.24,0,0,1,.48,0v5.45A.23.23,0,0,1,123.28,394.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M170.51,364.88c0,.09,0,.18,0,.26-.12.82-.24,1.73-.4,2.71s-.3,1.84-.48,2.84c-.09.52-.2,1.05-.3,1.6a1.42,1.42,0,0,0,0,.2h0a.09.09,0,0,0,0,.05c0,.06,0,.13-.05.2-.05.23-.08.45-.13.68h0c0,.12,0,.22-.07.34-.4,1.92-.88,4-1.46,6.13,0,.06,0,.14-.05.21s0,0,0,0l-.06.21c-.51,1.87-1.09,3.81-1.75,5.78-.08.25-.17.49-.25.75s-.14.41-.22.62l-.08.2h0s0,0,0,0h0c0,.06,0,.13-.06.2-.57,1.59-1.2,3.2-1.89,4.8-.15.36-.31.74-.48,1.1s-.37.83-.56,1.25a1.36,1.36,0,0,0-.1.21s0,0,0,0a1.39,1.39,0,0,1-.11.21c-.58,1.23-1.2,2.46-1.86,3.66-.15.29-.31.58-.47.86-.51.89-1,1.76-1.58,2.63a2.12,2.12,0,0,1-.12.2l0,.05h0l-.12.2c-.56.87-1.14,1.71-1.75,2.54l-.47.63c-.64.87-1.33,1.72-2,2.55-.15.18-.32.36-.48.54s-.52.6-.8.89l-.19.2h0a.07.07,0,0,1-.05,0,.71.71,0,0,1-.19.2c-.56.61-1.14,1.19-1.75,1.74l-.48.45c-.66.59-1.33,1.17-2,1.71a5.06,5.06,0,0,1-.47.37c-.37.29-.74.57-1.12.82s-.61.44-.92.64a5.5,5.5,0,0,1-.48.31c-.4.26-.8.51-1.21.75-.2.12-.41.25-.62.36l-.47.26h-6l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.67,1.67,0,0,1-.16-.12l-.12-.12h0a.72.72,0,0,1-.11-.15l-.05-.08,0-.07s0,0,0,0a.67.67,0,0,0-.06-.12s0-.07,0-.11l0-.1s0-.08,0-.12,0,0,0,0a1.25,1.25,0,0,1,0-.21v-4.61A1.58,1.58,0,0,1,135,411a1.55,1.55,0,0,1,1.1-.45h.55a1.3,1.3,0,0,1-.43-.2h0a1.11,1.11,0,0,1-.23-.19.67.67,0,0,1-.14-.16l0,0,0-.06a.61.61,0,0,1-.07-.1.93.93,0,0,0-.05-.1s0,0,0,0l0-.1a.76.76,0,0,1,0-.11.43.43,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.61a1.51,1.51,0,0,1,.27-.86.83.83,0,0,1,.19-.23,1.43,1.43,0,0,1,.68-.4h-.55a1.06,1.06,0,0,1-.31,0,2.46,2.46,0,0,1-.29-.09,1.19,1.19,0,0,1-.25-.13s0,0,0,0l-.21-.16a1.24,1.24,0,0,1-.14-.18l0-.05,0,0-.06-.09s0,0,0,0a1.15,1.15,0,0,1-.1-.23.53.53,0,0,1,0-.17s0,0,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.17-1.5h-1.54l-.23,0a.41.41,0,0,1-.16,0,1.51,1.51,0,0,1-.45-.2,1.19,1.19,0,0,1-.37-.37l0,0s0,0,0,0l-.08-.13a.24.24,0,0,1-.06-.11.24.24,0,0,0,0-.08,0,0,0,0,0,0,0,.76.76,0,0,1,0-.11.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21v-4.62a1.5,1.5,0,0,1,.45-1.08,1.52,1.52,0,0,1,.81-.43h0a1.66,1.66,0,0,1-.29-.1.77.77,0,0,1-.24-.12l0,0a1.16,1.16,0,0,1-.21-.16.59.59,0,0,1-.14-.18l0,0s0,0,0,0l-.08-.12a1,1,0,0,1-.09-.22,1.09,1.09,0,0,1,0-.17s0-.05,0-.08a1.81,1.81,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.54h3.45a1.54,1.54,0,0,1-.47-.21h0a2.31,2.31,0,0,1-.24-.2.52.52,0,0,1-.13-.17l0,0,0-.05-.07-.1a.42.42,0,0,0,0-.1.52.52,0,0,1-.06-.16.36.36,0,0,1,0-.09.52.52,0,0,1,0-.11v0a1.49,1.49,0,0,1,0-.21V374a1.48,1.48,0,0,1,.27-.85,1.37,1.37,0,0,1,.19-.23,1.35,1.35,0,0,1,.69-.4h-1.51l-.24,0-.15,0a1.43,1.43,0,0,1-.46-.2,1.58,1.58,0,0,1-.37-.36l0-.05,0,0-.06-.09s0,0,0,0a1.15,1.15,0,0,1-.1-.23.59.59,0,0,1,0-.17s0-.05,0-.08a2,2,0,0,1,0-.25v-4.57a1.54,1.54,0,0,1,1.54-1.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.55,
    cy: 363.59,
    r: 24.63,
    transform: "translate(-123.3 77.94) rotate(-21.51)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.7,385A24.63,24.63,0,1,1,165,351.46,24.54,24.54,0,0,1,155.7,385Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,364.84l2.76,4.87c1.84-1.44,2.16-2.86,1.49-4C149.48,364.31,147.91,364.37,146,364.84Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.37,361.38c.75,1.33,2.28,1.26,4.14.82l-2.78-4.9C137,358.71,136.68,360.17,137.37,361.38Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.19,345.3a21,21,0,1,0,28.66,7.93A21,21,0,0,0,133.19,345.3Zm17.26,27.42,1.75,3.09-2.26,1.28L148.21,374c-2.8,1.36-5.92,2-8.05,1.53l-.34-3.48a12.26,12.26,0,0,0,6.7-1l-3.12-5.51c-3.48,1-7.32,1.85-9.49-2-1.6-2.81-.95-6.42,3.12-9.27l-1.76-3.11,2.26-1.28,1.73,3.06a13.53,13.53,0,0,1,6.55-1.49l.44,3.42a13.31,13.31,0,0,0-5.31,1l3.16,5.57c3.48-1,7.36-1.91,9.53,1.92C155.22,366.23,154.53,369.83,150.45,372.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.49,
    cy: 393.57,
    r: 24.63,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -95.76, 42.81)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 118.49,
    cy: 393.57,
    r: 24.63,
    transform: "matrix(0.97, -0.25, 0.25, 0.97, -95.76, 42.81)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.38,396.3l-3.29,4.54c2.08,1.08,3.51.78,4.3-.32C120.3,399.26,119.6,397.85,118.38,396.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,387c-.89,1.23-.2,2.59,1,4.1l3.3-4.56C120.18,385.53,118.75,385.9,117.93,387Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.81,376.53a21,21,0,1,0,4.72,29.36A21,21,0,0,0,130.81,376.53Zm-17.74,27.11L111,406.52l-2.1-1.52,2.06-2.85c-2.41-2-4.25-4.56-4.75-6.68l3-1.76a12.1,12.1,0,0,0,3.72,5.66l3.71-5.13c-2.35-2.75-4.73-5.89-2.15-9.45,1.89-2.62,5.44-3.53,9.72-1l2.1-2.9,2.1,1.52-2.06,2.85a13.43,13.43,0,0,1,4.08,5.33l-2.92,1.83a13.18,13.18,0,0,0-3.16-4.39l-3.75,5.19c2.35,2.75,4.81,5.89,2.23,9.46C121,405.28,117.4,406.15,113.07,403.64Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.72,
    cy: 316.62,
    r: 24.63,
    transform: "translate(-30.35 18.76) rotate(-5.65)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174.72,
    cy: 316.62,
    r: 24.63,
    transform: "translate(-30.35 18.76) rotate(-5.65)",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.22,318.9v5.61c2.31-.35,3.29-1.43,3.29-2.79C179.51,320.17,178.12,319.44,176.22,318.9Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.42,311.65c0,1.52,1.37,2.21,3.2,2.75v-5.64C171.37,309.11,170.42,310.25,170.42,311.65Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.72,295.6a21,21,0,1,0,21,21A21,21,0,0,0,174.72,295.6Zm1.5,32.36v3.55h-2.6V328c-3.1-.19-6.11-1.2-7.76-2.63l1.43-3.2a12.13,12.13,0,0,0,6.33,2.41v-6.33c-3.51-.86-7.28-2-7.28-6.4,0-3.23,2.34-6,7.28-6.53v-3.58h2.6v3.52a13.61,13.61,0,0,1,6.43,1.93l-1.3,3.2a13.13,13.13,0,0,0-5.13-1.71v6.4c3.52.85,7.35,2,7.35,6.36C183.57,324.66,181.19,327.45,176.22,328Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.28,368.23A24.63,24.63,0,1,1,200.73,383,24.62,24.62,0,0,1,232.28,368.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.28,368.23A24.63,24.63,0,1,1,200.73,383,24.62,24.62,0,0,1,232.28,368.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.54,390.75l5.27,1.91c.46-2.3-.21-3.58-1.5-4.05C228.86,388.08,227.7,389.14,226.54,390.75Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.75,393.72c1.43.52,2.55-.52,3.68-2.06l-5.3-1.93C215.69,392,216.44,393.25,217.75,393.72Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.12,384.22a21,21,0,1,0,26.93-12.6A21,21,0,0,0,204.12,384.22Zm30.94,9.61,3.33,1.21-.88,2.45-3.31-1.2a13.88,13.88,0,0,1-5.11,6.4l-2.53-2.43a12.21,12.21,0,0,0,4.43-5.14L225,393c-2,3-4.36,6.17-8.5,4.67-3-1.1-4.89-4.26-3.65-9.07l-3.36-1.22.88-2.44,3.31,1.19a13.53,13.53,0,0,1,4-5.38l2.56,2.31a13,13,0,0,0-3.36,4.24l6,2.18c2-3,4.35-6.24,8.49-4.74C234.47,385.8,236.28,389,235.06,393.83Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.75,142.72h0V401.8h0A3.77,3.77,0,0,1,168,398V146.49A3.77,3.77,0,0,1,171.75,142.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.59,
    y: 137.79,
    width: 5.25,
    height: 15.87,
    rx: 1.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.85,139.13v13.21a1.33,1.33,0,0,1-1.33,1.32h-2.6a1.33,1.33,0,0,1-1.33-1.32V139.13a1.34,1.34,0,0,1,1.33-1.34h2.6A1.34,1.34,0,0,1,171.85,139.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.94,139.13v13.21a1.33,1.33,0,0,1-1.33,1.32h-.69a1.33,1.33,0,0,1-1.33-1.32V139.13a1.34,1.34,0,0,1,1.33-1.34h.69A1.34,1.34,0,0,1,169.94,139.13Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,151.65H165a4.68,4.68,0,0,1-4.69-4.68v-2.64a4.69,4.69,0,0,1,4.69-4.68h2.89a.78.78,0,0,1,.78.79v1.28a.78.78,0,0,1-.78.79H165a1.83,1.83,0,0,0-1.83,1.82V147a1.82,1.82,0,0,0,1.83,1.82h2.89a.79.79,0,0,1,.78.79v1.29A.78.78,0,0,1,167.84,151.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.84,151.65H165a4.68,4.68,0,0,1-4.69-4.68v-2.64a4.69,4.69,0,0,1,4.69-4.68h2.89a.78.78,0,0,1,.78.79v1.28a.78.78,0,0,1-.78.79H165a1.83,1.83,0,0,0-1.83,1.82V147a1.82,1.82,0,0,0,1.83,1.82h2.89a.79.79,0,0,1,.78.79v1.29A.78.78,0,0,1,167.84,151.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 390.53 169.21 392.66 169.21 396.76 163.26 397.93 163.26 390.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 378.91 169.21 381.05 169.21 385.14 163.26 386.32 163.26 378.91",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 367.3 169.21 369.43 169.21 373.52 163.26 374.7 163.26 367.3",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 355.68 169.21 357.81 169.21 361.91 163.26 363.08 163.26 355.68",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 344.06 169.21 346.2 169.21 350.29 163.26 351.47 163.26 344.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 332.45 169.21 334.58 169.21 338.68 163.26 339.85 163.26 332.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 320.83 169.21 322.97 169.21 327.06 163.26 328.24 163.26 320.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 309.22 169.21 311.35 169.21 315.44 163.26 316.62 163.26 309.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 297.6 169.21 299.73 169.21 303.83 163.26 305 163.26 297.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 285.98 169.21 288.12 169.21 292.21 163.26 293.39 163.26 285.98",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 274.37 169.21 276.5 169.21 280.6 163.26 281.77 163.26 274.37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 262.75 169.21 264.89 169.21 268.98 163.26 270.15 163.26 262.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 251.13 169.21 253.27 169.21 257.36 163.26 258.54 163.26 251.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 239.52 169.21 241.65 169.21 245.75 163.26 246.92 163.26 239.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 227.9 169.21 230.04 169.21 234.13 163.26 235.31 163.26 227.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 216.29 169.21 218.42 169.21 222.51 163.26 223.69 163.26 216.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 204.67 169.21 206.81 169.21 210.9 163.26 212.07 163.26 204.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 193.05 169.21 195.19 169.21 199.28 163.26 200.46 163.26 193.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 181.44 169.21 183.57 169.21 187.67 163.26 188.84 163.26 181.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 169.82 169.21 171.96 169.21 176.05 163.26 177.22 163.26 169.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.26 158.21 169.21 160.34 169.21 164.43 163.26 165.61 163.26 158.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,117.37h-7.3c-.52,0-.84.63-.69,1.36l5.27,26.67c.13.67.61,1.19,1.08,1.19h4.83c.47,0,.79-.52.72-1.19l-2.81-26.67C165.37,118,164.87,117.37,164.35,117.37Zm.34,24.94a1.44,1.44,0,0,1-.1.79,2,2,0,0,1-.33-.79l-.3-2a1.47,1.47,0,0,1,.1-.8,2,2,0,0,1,.33.8Zm-3.62-22.48c.51,0,1,.58,1.11,1.29l.3,1.95c.11.71-.22,1.29-.72,1.29h0c-.51,0-1-.58-1.11-1.29l-.3-1.95c-.11-.71.22-1.29.72-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.35,117.37h-7.3c-.52,0-.84.63-.69,1.36l5.27,26.67c.13.67.61,1.19,1.08,1.19h4.83c.47,0,.79-.52.72-1.19l-2.81-26.67C165.37,118,164.87,117.37,164.35,117.37Zm.34,24.94a1.44,1.44,0,0,1-.1.79,2,2,0,0,1-.33-.79l-.3-2a1.47,1.47,0,0,1,.1-.8,2,2,0,0,1,.33.8Zm-3.62-22.48c.51,0,1,.58,1.11,1.29l.3,1.95c.11.71-.22,1.29-.72,1.29h0c-.51,0-1-.58-1.11-1.29l-.3-1.95c-.11-.71.22-1.29.72-1.29Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,145.4c.13.67.61,1.19,1.08,1.19h3.45c.48,0,.79-.52.72-1.19l-2.81-26.67c-.07-.73-.58-1.36-1.1-1.36h-5.92c-.52,0-.84.63-.69,1.36Zm3.06-3.09c.1.7-.21,1.27-.71,1.27s-1-.57-1.09-1.27l-.3-2c-.11-.71.21-1.28.7-1.28s1,.57,1.1,1.28Zm-5-22.48h1.38c.51,0,1,.58,1.11,1.29l.3,1.95c.11.71-.22,1.29-.72,1.29h-1.38c-.51,0-1-.58-1.11-1.29l-.3-1.95C158.86,120.41,159.19,119.83,159.69,119.83Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.84,148.79H165a1.82,1.82,0,0,1-1.83-1.82v-2.64a1.82,1.82,0,0,1,1.34-1.75v-.88l-.15-.36h0s0,0,0-.05l0-.05c0-.09-.16-1.17-.16-1.26v0a1.1,1.1,0,0,1,0-.18,4.66,4.66,0,0,0-3.86,4.56V147a4.68,4.68,0,0,0,4.69,4.68h2.89a.78.78,0,0,0,.78-.78v-1.29A.79.79,0,0,0,167.84,148.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.84,148.79H165a1.82,1.82,0,0,1-1.83-1.82v-2.64a1.82,1.82,0,0,1,1.34-1.75v-.88l-.15-.36h0s0,0,0-.05l0-.05c0-.09-.16-1.17-.16-1.26v0a1.1,1.1,0,0,1,0-.18,4.66,4.66,0,0,0-3.86,4.56V147a4.68,4.68,0,0,0,4.69,4.68h2.89a.78.78,0,0,0,.78-.78v-1.29A.79.79,0,0,0,167.84,148.79Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 170.85,
    y: 130.64,
    width: 159.88,
    height: 287.56,
    rx: 9.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.85,
    y: 130.64,
    width: 159.88,
    height: 287.56,
    rx: 9.58,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.33,140.27V408.05a3.93,3.93,0,0,1-4,3.92H179.8a3.51,3.51,0,0,1-3.56-3.59V140a3.16,3.16,0,0,1,3-3.29h35.39a2.5,2.5,0,0,1,2.29,1.6l1.46,3.6a2.47,2.47,0,0,0,2.27,1.57H281a2.47,2.47,0,0,0,2.28-1.55l1.46-3.62a2.51,2.51,0,0,1,2.28-1.6h34.89A3.58,3.58,0,0,1,325.33,140.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.76,137a2,2,0,1,1-2-2A2.05,2.05,0,0,1,250.76,137Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.9,137a1.31,1.31,0,1,1-1.31-1.31A1.3,1.3,0,0,1,254.9,137Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.39,
    y: 153.81,
    width: 144.79,
    height: 245.67,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.39,
    y: 153.81,
    width: 144.79,
    height: 245.67,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.32,
    y: 344.46,
    width: 136.93,
    height: 29.9,
    rx: 3.94,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.32,
    y: 301.31,
    width: 136.93,
    height: 38.06,
    rx: 3.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.32,
    y: 192.14,
    width: 136.93,
    height: 105.1,
    rx: 3.94,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.32,
    y: 158.49,
    width: 136.93,
    height: 29.9,
    rx: 3.94,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M251.82,319.72l1.3.72-.44.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.31-.72-1.31-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.44.78Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M256.81,319.72l1.3.72-.45.77-1.32-.77v1.47h-.87v-1.46l-1.32.76-.45-.77,1.31-.72-1.31-.73.45-.78,1.32.77v-1.46h.87V319l1.32-.78.45.78Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M261.79,319.72l1.31.72-.45.77-1.33-.77v1.47h-.87l0-1.46-1.32.76-.46-.77,1.32-.72L258.7,319l.46-.78,1.32.77,0-1.46h.87V319l1.33-.78.45.78Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M266.78,319.72l1.3.72-.44.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.31-.72-1.31-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.44.78Z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M274.69,319.72l1.31.72-.45.77-1.33-.77v1.47h-.87l0-1.46-1.32.76-.46-.77,1.32-.72L271.6,319l.46-.78,1.32.77,0-1.46h.87V319l1.33-.78.45.78Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M279.68,319.72l1.3.72-.44.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.31-.72-1.31-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.44.78Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M284.66,319.72l1.31.72-.45.77-1.33-.77,0,1.47h-.87v-1.46l-1.32.76-.46-.77,1.32-.72-1.32-.73.46-.78,1.32.77v-1.46h.87l0,1.47,1.33-.78.45.78Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M289.65,319.72l1.31.72-.45.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.32-.72-1.32-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.45.78Z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M297.56,319.72l1.31.72-.45.77-1.32-.77v1.47h-.87v-1.46l-1.32.76-.46-.77,1.32-.72-1.32-.73.46-.78,1.32.77v-1.46h.87V319l1.32-.78.45.78Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M302.55,319.72l1.31.72-.45.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.32-.72-1.32-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.45.78Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M307.54,319.72l1.3.72-.44.77-1.33-.77v1.47h-.87v-1.46l-1.31.76-.46-.77,1.31-.72-1.31-.73.46-.78,1.31.77v-1.46h.87V319l1.33-.78.44.78Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 192.55,
    y: 311.64,
    width: 24.63,
    height: 16.32,
    rx: 2.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 192.55,
    y: 320.44,
    width: 24.63,
    height: 4.07
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2,317.53a1.23,1.23,0,1,1-1.23-1.22A1.23,1.23,0,0,1,215.2,317.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M213.6,317.53a1.23,1.23,0,1,1-1.23-1.22A1.23,1.23,0,0,1,213.6,317.53Z",
    style: {
      fill: "#fff"
    }
  }), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M204.25,168.8l-2.7,8h-.89L198.31,170,196,176.81h-.89l-2.7-8h.87l2.31,6.88,2.4-6.88h.79l2.35,6.92,2.35-6.92Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "201.89 177.28 200.32 177.28 198.31 171.44 196.29 177.28 194.73 177.28 191.71 168.32 193.59 168.32 195.56 174.21 197.61 168.32 199.08 168.32 201.09 174.24 203.1 168.32 204.92 168.32 201.89 177.28",
    style: {
      fill: "#fff"
    }
  }), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M209.7,173.08v3.73h-.77v-.94a2.27,2.27,0,0,1-2.08,1c-1.36,0-2.19-.71-2.19-1.75s.59-1.7,2.32-1.7h1.91V173c0-1-.58-1.59-1.7-1.59a3.13,3.13,0,0,0-2,.71l-.36-.61a3.84,3.84,0,0,1,2.45-.81A2.14,2.14,0,0,1,209.7,173.08Zm-.81,1.92v-1H207c-1.16,0-1.54.46-1.54,1.08s.56,1.13,1.52,1.13A1.92,1.92,0,0,0,208.89,175Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.85,177.34c-1.6,0-2.67-.9-2.67-2.23,0-.65.27-2.18,2.8-2.18h1.43c0-.49-.21-1-1.22-1a2.61,2.61,0,0,0-1.69.59l-.43.38-.87-1.45.31-.26a4.3,4.3,0,0,1,2.76-.93,2.61,2.61,0,0,1,2.91,2.82v4.2h-1.73V177A3.32,3.32,0,0,1,206.85,177.34Zm.15-2.85c-1.07,0-1.07.39-1.07.6,0,.57.66.66,1,.66a1.47,1.47,0,0,0,1.43-.85v-.41Z",
    style: {
      fill: "#fff"
    }
  }), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M211.91,168.31h.81v8.5h-.81Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211.43,
    y: 167.84,
    width: 1.77,
    height: 9.44,
    style: {
      fill: "#fff"
    }
  }), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M215,168.31h.82v8.5H215Z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.51,
    y: 167.84,
    width: 1.77,
    height: 9.44,
    style: {
      fill: "#fff"
    }
  }), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M223.3,174.05h-5a2.22,2.22,0,0,0,2.37,2.09,2.36,2.36,0,0,0,1.84-.79l.46.53a3.19,3.19,0,0,1-5.49-2.08,2.9,2.9,0,0,1,3-3.06,2.87,2.87,0,0,1,2.91,3.06C223.31,173.87,223.3,174,223.3,174.05Zm-5-.61h4.27a2.14,2.14,0,0,0-4.27,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.61,177.34A3.47,3.47,0,0,1,217,173.8a3.41,3.41,0,1,1,6.81,0v.72h-4.93a1.77,1.77,0,0,0,1.79,1.15,1.9,1.9,0,0,0,1.48-.63l.36-.41,1.08,1.24-.26.32A3.43,3.43,0,0,1,220.61,177.34ZM218.86,173H222a1.6,1.6,0,0,0-1.55-1A1.58,1.58,0,0,0,218.86,173Z",
    style: {
      fill: "#fff"
    }
  }), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M228.14,176.44a1.91,1.91,0,0,1-1.27.42,1.59,1.59,0,0,1-1.76-1.75v-3.64H224v-.68h1.08v-1.32h.81v1.32h1.83v.68h-1.83v3.6a1,1,0,0,0,1,1.09,1.37,1.37,0,0,0,.89-.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.87,177.34a2.07,2.07,0,0,1-2.24-2.23V172h-1.08v-1.64h1.08V169h1.77v1.32h1.83V172H226.4v3.12c0,.51.22.62.56.62a.85.85,0,0,0,.57-.19l.47-.42.73,1.47-.27.25A2.44,2.44,0,0,1,226.87,177.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.62,169.63h-9.87a1,1,0,1,1,0-1.91h9.87a1,1,0,1,1,0,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.62,179.16h-9.87a1,1,0,1,1,0-1.9h9.87a1,1,0,1,1,0,1.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.62,174.4h-9.87a1,1,0,1,1,0-1.91h9.87a1,1,0,1,1,0,1.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M236.55,254.87h-42.1a2.39,2.39,0,1,1,0-4.77h42.1a2.39,2.39,0,0,1,0,4.77Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M254.67,268.22H194.45a2.39,2.39,0,1,1,0-4.77h60.22a2.39,2.39,0,0,1,0,4.77Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M307.12,268.22H290.77a2.39,2.39,0,0,1,0-4.77h16.35a2.39,2.39,0,1,1,0,4.77Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M222.25,277.76h-27.8a2.39,2.39,0,1,1,0-4.77h27.8a2.39,2.39,0,0,1,0,4.77Z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M307.12,277.76h-23a2.39,2.39,0,0,1,0-4.77h23a2.39,2.39,0,1,1,0,4.77Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M249,287.29h-54.5a2.38,2.38,0,1,1,0-4.76H249a2.38,2.38,0,0,1,0,4.76Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M307.12,287.29H293.63a2.38,2.38,0,0,1,0-4.76h13.49a2.38,2.38,0,1,1,0,4.76Z"
  }))), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M294.76,358.07c0,1.7-1.24,2.73-3.27,2.73h-2.16v2.53h-.84v-8h3C293.52,355.32,294.76,356.35,294.76,358.07Zm-.85,0c0-1.28-.84-2-2.45-2h-2.13v4h2.13C293.07,360.06,293.91,359.33,293.91,358.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.81,363.81H288v-9h3.48c2.31,0,3.75,1.23,3.75,3.22s-1.44,3.21-3.75,3.21h-1.68Zm0-4.23h1.65c1.31,0,2-.51,2-1.51s-.67-1.54-2-1.54h-1.65Z",
    style: {
      fill: "#fff"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M301.21,361.19h-4.46l-1,2.14h-.88l3.66-8h.84l3.66,8h-.89Zm-.31-.68L299,356.2l-1.93,4.31Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.8,363.81h-1.94l-1-2.14h-3.85l-1,2.14h-1.93l4.1-9h1.45Zm-6-3.78h2.37L299,357.37Z",
    style: {
      fill: "#fff"
    }
  }), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M306.66,360.56v2.77h-.83v-2.77l-3.21-5.24h.91l2.74,4.5,2.75-4.5h.85Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "307.14 363.81 305.35 363.81 305.35 360.7 301.77 354.85 303.8 354.85 306.27 358.9 308.75 354.85 310.72 354.85 307.14 360.7 307.14 363.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.14,364.62H196.58a.51.51,0,0,1-.5-.4l-2.42-10.15a.5.5,0,0,1,.5-.63h15.4a.5.5,0,0,1,.4.19.51.51,0,0,1,.1.44l-2.42,10.15A.51.51,0,0,1,207.14,364.62Zm-10.15-1h9.74l2.17-9.11H194.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.86,364.62a.52.52,0,0,1-.52-.52V354a.52.52,0,0,1,1,0V364.1A.52.52,0,0,1,201.86,364.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.72,364.6h-.06a.52.52,0,0,1-.46-.57l1.19-10.13a.52.52,0,0,1,1,.12l-1.19,10.13A.52.52,0,0,1,204.72,364.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,364.6a.52.52,0,0,1-.51-.46L197.3,354a.51.51,0,0,1,.45-.57.52.52,0,0,1,.58.45L199.52,364a.52.52,0,0,1-.46.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,357.92H195a.52.52,0,0,1,0-1h13.76a.52.52,0,0,1,0,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.9,361.43H195.82a.52.52,0,0,1-.52-.52.52.52,0,0,1,.52-.52H207.9a.53.53,0,0,1,.52.52A.52.52,0,0,1,207.9,361.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,368.31a1.71,1.71,0,1,1,1.71-1.71A1.72,1.72,0,0,1,197,368.31Zm0-2.38a.67.67,0,0,0-.67.67.67.67,0,1,0,1.34,0A.67.67,0,0,0,197,365.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,368.31a1.71,1.71,0,1,1,1.71-1.71A1.72,1.72,0,0,1,206.68,368.31Zm0-2.38a.68.68,0,0,0-.68.67.69.69,0,0,0,.68.68.68.68,0,0,0,.67-.68A.67.67,0,0,0,206.68,365.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.16,354.47a.51.51,0,0,1-.17,0l-2.46-.85a.51.51,0,0,1-.32-.66.52.52,0,0,1,.66-.32l2.46.85a.53.53,0,0,1,.32.66A.5.5,0,0,1,194.16,354.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.79,
    cy: 222.23,
    r: 20.4,
    transform: "translate(-83.69 242.42) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.57,227.32a5.11,5.11,0,0,1-5-6,5.3,5.3,0,0,1,5.31-4.17h5.64a.12.12,0,0,0,.12-.12v-3a1.28,1.28,0,0,0-1.28-1.28H241a1.27,1.27,0,0,0-1.27,1.28v16.46a1.28,1.28,0,0,0,1.27,1.28h18.3a1.28,1.28,0,0,0,1.28-1.28v-3a.13.13,0,0,0-.12-.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.53,218.77h-6a3.46,3.46,0,1,0,0,6.92h6a1.28,1.28,0,0,0,1.28-1.28V220A1.27,1.27,0,0,0,260.53,218.77Zm-5.75,4.75a1.3,1.3,0,1,1,1.3-1.29A1.29,1.29,0,0,1,254.78,223.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.67,
    y: 145.01,
    width: 1.84,
    height: 2.45,
    transform: "translate(387.19 292.47) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.67,
    y: 144.19,
    width: 1.84,
    height: 3.27,
    transform: "translate(381.18 291.65) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.67,
    y: 143.37,
    width: 1.84,
    height: 4.09,
    transform: "translate(375.18 290.83) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.67,
    y: 142.55,
    width: 1.84,
    height: 4.91,
    transform: "translate(369.18 290.01) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.36,
    y: 144.11,
    width: 1.09,
    height: 2.45,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.21,
    y: 143.21,
    width: 8.7,
    height: 4.25,
    transform: "translate(627.11 290.67) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.61,136.67c-13.19,36.54-56.1,136.89-141.37,177.82V140a3.16,3.16,0,0,1,3-3.29h35.39a2.5,2.5,0,0,1,2.29,1.6l1.46,3.6a2.47,2.47,0,0,0,2.27,1.57H281a2.47,2.47,0,0,0,2.28-1.55l1.46-3.62a2.51,2.51,0,0,1,2.28-1.6Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.33,268v140.1a3.93,3.93,0,0,1-4,3.92H179.8a3.51,3.51,0,0,1-3.56-3.59V344.7C215.63,292.85,283.32,274.48,325.33,268Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M399.37,105.69H370.64a8.84,8.84,0,0,0-8.84,8.85v25a8.84,8.84,0,0,0,8.84,8.85H379l-7,13.89,13-13.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,399.37,105.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.37,105.69H370.64a8.84,8.84,0,0,0-8.84,8.85v25a8.84,8.84,0,0,0,8.84,8.85H379l-7,13.89,13-13.89h14.39a8.85,8.85,0,0,0,8.85-8.85v-25A8.85,8.85,0,0,0,399.37,105.69Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.51,133.3a1.31,1.31,0,0,1-1-.46l-5.59-6.59a1.31,1.31,0,1,1,2-1.7l4.6,5.42,7.59-9a1.31,1.31,0,0,1,2,1.7l-8.59,10.12A1.33,1.33,0,0,1,383.51,133.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.01,
    cy: 126.93,
    r: 14.26,
    transform: "translate(23.01 309.42) rotate(-45)",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M363.46,197.17c3.2,7.28,6.8,16,10.79,22.24A2.72,2.72,0,0,0,373,219c-.92,0-1,.3-.86.21,1.54-1,2.73-2.79,4-4.58a116.67,116.67,0,0,0,6.1-10.24,2.42,2.42,0,0,1,4.43,1.91,93.21,93.21,0,0,1-5,11.64c-2,3.92-6.27,11.21-11.79,7.74-2.84-2.16-4.43-5.3-6.24-8-3.28-5.37-6.22-10.82-9.06-16.43-2.79-6,6-10.14,8.84-4.08Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.63,193.88c4.36.27,11.65,14,11.65,14l-13.36,9.9s-2.38-20.26-2.38-20.29S360.63,193.88,360.63,193.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.28,207.91l-6.65,4.93L361,216.25l-2.1,1.56s-1.44-12.24-2.07-17.7c-.19-1.57-.31-2.58-.31-2.59s4.09-3.63,4.09-3.63c3.6.22,9.21,9.66,11.05,12.93C372.06,207.5,372.28,207.91,372.28,207.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.27 206.45 374.15 208.59 361.95 217.81 359.85 214.27 372.27 206.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "374.14 208.59 366.06 214.7 361.95 217.81 361.02 216.25 359.85 214.27 365 211.02 371.68 206.82 372.27 206.45 374.14 208.59",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.17,203.53a.66.66,0,0,0,.56.83l7.36,1a.85.85,0,0,0,.93-.63l3.64-14.28a.76.76,0,0,0-.55-.94l-7.36-1a1,1,0,0,0-.94.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.64,189.26,375,203.68a.56.56,0,0,0,.48.78l6.24.85c.42.06,1.21-.07,1.32-.47l3.68-14.48c.11-.41-.56-.83-1-.89l-6.24-.86A.76.76,0,0,0,378.64,189.26Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.87,205.82l-.92-8.3-5.39,6.26s-1.16,5.36,3.71,5Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.71 195.96 378.93 202.06 380.56 203.78 385.95 197.52 380.71 195.96",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.33,213,362,217.81l-.93-1.56-2.1,1.56s-1.44-12.24-2.07-17.7C358.06,201.08,367.18,202.46,368.33,213Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.8,344.88l2.68,5.12s2.3-1.22,5.95-3.22c1.05-.57,2.21-1.2,3.45-1.9,3.46-1.9,7.61-4.21,12-6.69l2.87-1.65c15.21-8.71,27.68-17.07,27.68-21.64,0-7.66-5.55-22.23-13.39-36.81-5.24-9.74-9.6-17.58-9.6-17.58l-18.62,11.4s6.34,8.48,12.84,17.82c7.58,10.89,15.37,22.93,13.59,24.13-1.36.91-8.29,6.33-15.95,12.39l-1.39,1.09c-4.13,3.27-8.4,6.65-12.08,9.58l-3,2.35Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.81,271.91s6.34,8.48,12.84,17.82L373,278.09c-5.24-9.74-9.6-17.58-9.6-17.58Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.85,339.27l1.58,7.51c4.58-2.5,11.28-6.2,18.31-10.24-1.19-3.62-2.56-7.7-3.45-10.29C349.57,330.76,343.43,335.64,338.85,339.27Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.59,281.38l3.59,10.94.73,2.25,5.47,16.65.62,1.91,3.62,11,4.2,12.8,1.94,5.92c0,.67.07,1.35.12,2,1.84,28.28,16.57,65.24,16.57,65.24l5.26-1.43c-1.87-22.21-5.86-48.1-9.84-70.5-.66-3.72-1.31-7.35-2-10.85-.37-2-.73-3.89-1.08-5.76-.76-4-1.48-7.74-2.19-11.24-.33-1.66-.65-3.25-.95-4.8-.77-3.82-1.47-7.22-2.09-10.14s-1.11-5.33-1.51-7.18c-.58-2.69-.9-4.19-.9-4.19Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.14,339.39c.68,0,.27,8.4.27,8.4s-5.17,5.24-6.27,10.27-4.15,2.27-4.24-3.33-.15-9.87-.21-13.85S331.06,339.33,338.14,339.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.33,352.24a10.83,10.83,0,0,1,1-3.5l.06-.07h0l.05,0a.2.2,0,0,1,.17,0c.08,0,2.05.7,2.54,1.83a1.3,1.3,0,0,1,0,1.09c-.17.38-.41.57-.69.56-.44,0-.89-.61-1.27-1.29a3.39,3.39,0,0,1-.18,1.88.88.88,0,0,1-.56.46.78.78,0,0,1-.89-.19A1.15,1.15,0,0,1,336.33,352.24Zm1.17-2.73c-.51,1.24-.95,2.79-.62,3.18,0,0,.12.13.45.05a.53.53,0,0,0,.29-.25A5.59,5.59,0,0,0,337.5,349.51Zm2.33,1.46a.8.8,0,0,0-.08-.33,3.67,3.67,0,0,0-1.82-1.42c.49,1.24,1.16,2.43,1.54,2.45.11,0,.22-.19.27-.31A.92.92,0,0,0,339.83,351Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359,407.74c0-.68,8.4-.15,8.4-.15s5.16,5.25,10.17,6.43,2.21,4.18-3.39,4.18H360.28C356.3,418.2,358.78,414.81,359,407.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76,409.74a10.49,10.49,0,0,1-3.47-1.06l-.08-.06h0l0-.05a.25.25,0,0,1,0-.17c0-.08.74-2,1.88-2.51a1.28,1.28,0,0,1,1.08,0c.38.18.57.42.55.7,0,.44-.62.89-1.3,1.25a3.39,3.39,0,0,1,1.88.21.89.89,0,0,1,.45.56.82.82,0,0,1-.21.9A1.16,1.16,0,0,1,371.76,409.74Zm-2.71-1.21c1.24.53,2.78,1,3.17.67,0,0,.14-.12.06-.45a.45.45,0,0,0-.24-.29C371.43,408.11,370,408.33,369.05,408.53Zm1.51-2.3a.8.8,0,0,0-.34.07,3.67,3.67,0,0,0-1.44,1.8c1.24-.47,2.44-1.13,2.46-1.5,0-.12-.18-.23-.3-.28A.92.92,0,0,0,370.56,406.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,287.44l1.22,1.14,18.1-12.28L370,270.72a18.15,18.15,0,0,1-.85,5.8C368.14,278.85,356.15,285.66,353,287.44Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.59,281.38l3.59,10.94c9.89,2.35,16.29,3.11,20.41,3.08-.6-2.91-1.11-5.33-1.51-7.18-.58-2.69-.9-4.19-.9-4.19Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.27,276.31l-18.11,12.28L353,287.45l-4.11-3.88v9.71l-25-4.48c-3.79-16.78-3.31-29.21-1.67-37.75a46.33,46.33,0,0,1,4.05-12.39l0,0,.32-3.17L360.41,239l.33,2.21,1.63,10.93,7.61,18.6Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,283.57v-10.8s4.83,8.08,4.11,14.67Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.13 287.44 371.45 273.42 373.09 276.11 353.64 289.73 352.13 287.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.13 287.44 371.45 273.42 373.09 276.11 353.64 289.73 352.13 287.44",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.79 286.6 349.35 291.29 349.35 293.9 323.59 289.73 322.79 286.6",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.79 286.6 349.35 291.29 349.35 293.9 323.59 289.73 322.79 286.6",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.4,239.58s-2.49,9.16-11.22,11.47a46.33,46.33,0,0,1,4.05-12.39l0,0Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.37,252.12c-3.23-3.12-4.16-10.93-4.16-10.93h2.53Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.89,240.64a1.06,1.06,0,0,1-2.12,0,1.06,1.06,0,0,1,2.12,0Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.94,236.68c-7.82-1.78-.1-1.67-2.64-37a15.74,15.74,0,0,1,.42-5.33,6.07,6.07,0,0,1,6.54-4.32c1.36.15,2.57.29,2.84.3.73,0,1.48.05,2.23.1a105.92,105.92,0,0,1,15.19,1.72c1.24.25,2.51.55,3.75.84.4.1,5,.81,5.36.91,0,0,5.26,8.17,4.78,14.09-.27,3.3-1.39,5.73-1.48,13.65-.2,18,3.56,17.45-4.25,18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,221.62c-.2,18,3.56,17.46-4.25,18l-32.74-2.91c-6.44-1.45-2.34-1.64-2.12-21.44,0-3.4,0-7.37-.28-12-.07-1.14-.15-2.33-.24-3.55a15.65,15.65,0,0,1,.42-5.32,6.06,6.06,0,0,1,6.54-4.33c1.36.15,2.57.29,2.84.29.72,0,1.48.06,2.23.11a109.07,109.07,0,0,1,15.19,1.71c1.24.27,2.5.55,3.76.85.4.1,5,.81,5.35.92,0,0,5.26,8.16,4.79,14.07C365.14,211.27,364,213.7,363.93,221.62Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,214.77s-6.94,7.53-18.65.46c0-3.4,0-7.37-.28-12a65.8,65.8,0,0,1,14-3.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.47,199l7.29-4.15,2.57,6.87s-4.69,3.62-8.87,1.1Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.73 194.69 372.41 200.27 368.33 201.74 365.76 194.87 371.73 194.69",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.42,195.47a81.8,81.8,0,0,0,9.09,22l.21.35a3,3,0,0,0-.8-.8,2.86,2.86,0,0,0-2.54-.45c3.14-1.65,5.62-4.61,8.24-7.14,3.11-3.23,6.23-6.61,9.3-10a2.43,2.43,0,0,1,3.89,2.84,104.36,104.36,0,0,1-12.22,17.42,19.77,19.77,0,0,1-5.94,4.83,5.77,5.77,0,0,1-7.49-2.21,66.27,66.27,0,0,1-11.31-25.15c-1-6.43,8.23-8.14,9.57-1.76Z",
    style: {
      fill: "#ebc0bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.48,190c-5.3-.63-8.54,5.54-6.87,19.71h16.57S339.2,191,330.48,190Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.48,190c-5.3-.63-8.54,5.54-6.87,19.71h16.57S339.2,191,330.48,190Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.77 206.45 340.74 208.59 340.8 211.01 323.17 211.01 322.77 206.45",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.77 206.45 340.74 208.59 340.8 211.01 323.17 211.01 322.77 206.45",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.89,149.56s3.81-2.75,10.25-.64,13.13,9.05,10.18,19-2.58,16.3-2.58,16.3-22.14-3.67-26.87-8S330.89,147,343.89,149.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.32,173.42c.77,5,1.39,14.18-2.16,17.09a136,136,0,0,0,13.86,7c3.31-3.76,1.34-5.3,1.34-5.3-5.4-1.93-5.11-6-4-9.71Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,177.13l5.34,5.37a15.7,15.7,0,0,0-.57,2.67c-2.07-.54-4.84-3.17-5-5.39A7.26,7.26,0,0,1,343,177.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.4,160.61c-1.6,7.92-2.45,11.24.32,16.47,4.16,7.88,14,8.59,17.86,1.43,3.49-6.45,5.53-18.33-1.07-23.84A10.36,10.36,0,0,0,340.4,160.61Z",
    style: {
      fill: "#eec1bb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,165.66c-.16.66,0,1.3.45,1.43s.88-.29,1-1,0-1.3-.45-1.44S349.47,165,349.3,165.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.38,168c-.16.66,0,1.3.45,1.44s.87-.3,1-1,0-1.3-.45-1.43S357.54,167.33,357.38,168Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.23,167l1.62,0S358.77,168,358.23,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.58,168.65a19.74,19.74,0,0,0,1.2,4.93,2.68,2.68,0,0,1-2.35-.28Z",
    style: {
      fill: "#d4827d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.21,174.57a6.51,6.51,0,0,0,1,.43.17.17,0,0,0,.23-.13.2.2,0,0,0-.13-.25,5.67,5.67,0,0,1-3.56-3.35.19.19,0,0,0-.24-.14.2.2,0,0,0-.12.25A5.92,5.92,0,0,0,349.21,174.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.15,161.15a.35.35,0,0,0,.3,0,2.9,2.9,0,0,1,2.75.05.36.36,0,0,0,.52-.12.42.42,0,0,0-.14-.56,3.63,3.63,0,0,0-3.48-.11.41.41,0,0,0-.16.54A.39.39,0,0,0,349.15,161.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.74,164.71a.34.34,0,0,0,.28,0,.38.38,0,0,0,.25-.49,4.12,4.12,0,0,0-2.36-2.82.36.36,0,0,0-.47.25.42.42,0,0,0,.26.51,3.35,3.35,0,0,1,1.84,2.26A.42.42,0,0,0,361.74,164.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.15,164.68l1.63,0S350.69,165.7,350.15,164.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.24,166.44s5.84-3.58,6.55-12.42c0,0,9.74-.31,13.16,8.32,0,0-1.22-12.41-15.12-12.93s-10.07,14.76-9,16.35S342.24,166.44,342.24,166.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.19,166.2a6.45,6.45,0,0,0,2.87,4c1.89,1.12,3.36-.64,3.27-2.89-.07-2-1.14-5.06-3.25-5.25S335.69,164.08,336.19,166.2Z",
    style: {
      fill: "#eec1bb"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEWalletRafiki);
export default __webpack_public_path__ + "static/media/e-wallet-rafiki.8c956a07a60076de8443c217f1d85f5e.svg";
export { ForwardRef as ReactComponent };